import React from 'react';
import Summernote from 'react-summernote';
import { connect } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.css';
import "assets/scss/summernote.scss";

import CustomInput from '../../components/CustomInput/CustomInput';
import ReactSelect from '../../components/Select/ReactSelect';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { withStyles } from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import cellfind from "assets/img/cellfind.png";
import panacea from "assets/img/panacea.jpg";
import simigenix from "assets/img/simigenix.png";

import Api from 'api/Api.js';
import EmailEndpoints from 'api/EmailEndpoints';
import EmailPreview from './EmailPreview';
import SingleInputModal from '../../components/Modal/SingleInputModal';
import Button from '../../components/CustomButtons/Button';
import { faPlus, faPaperPlane, faPresentation, faBookmark, faCopy } from '@fortawesome/pro-solid-svg-icons';
import SmallModal from '../../components/Modal/SmallModal';
import NotificationModal from '../../components/Modal/NotificationModal';
import SelectTemplate from './SelectTemplate';
import Loading from '../../components/Loading/Loading';

const getLetterheadImage = (letterhead) => {
    switch (letterhead) {
        case "Cellfind":
            return cellfind;
        case "Panacea":
            return panacea;
        case "Simigenix":
            return simigenix;
    }
}

const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
}

class SelectEmailAddress extends React.Component {
    constructor(props) {
        super(props);
        if (props.defaultValue) {
            this.state = {
                selected: props.defaultValue
            }
        }
    }

    state = {
        selected: []
    }

    render() {
        return (
            <ReactSelect
                label={this.props.label}
                options={
                    this.props.allEmails && this.props.allEmails.length > 0 ?
                        this.props.allEmails.map(e => ({ label: e.emailaddress, value: e.emailaddress }))
                        :
                        [{ label: 'Loading...', value: '' }]
                }
                onChange={(value) => this.setState({ selected: value })}
                isValidNewOption={verifyEmail}
                onCreateOption={(new_email) =>
                    this.setState({ loadingNewEmail: true }, () =>
                        Api.get(EmailEndpoints.add, { email: new_email })
                            .then(({ data }) => this.props.add(data.emailaddress, () => this.setState({ selected: this.state.selected.concat([{ label: data.emailaddress, value: data.emailaddress }]) })))
                    )
                }
                placeholder={this.props.placeholder}
                value={this.state.selected}
                isCreateable
                isClearable
                isSearchable
                isMulti
                isLoading={!this.props.allEmails || this.props.allEmails.length === 0}
                isDisabled={!this.props.allEmails || this.props.allEmails.length === 0}
            />
        );
    }
}

class SummernoteOptimization extends React.Component {

    state = {
        body: '<p style="font-family: Roboto"></p>'
    }

    componentDidMount() {
        var elements = document.getElementsByClassName('note-popover'); //.length //.item(0).getElementsByClassName.display = 'none';
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.display = 'none';
        }
    }

    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    onChange = (text) => {
        this.setState({ body: text });

        if (process.env.NODE_ENV === 'production') {
            if (text)
                window.onbeforeunload = () => true;
            else
                window.onbeforeunload = null;
        }
    }

    onImageUpload = (fileList) => {
        const reader = new FileReader();

        if (fileList && fileList[0]) {
            reader.onloadend = () => {
                Summernote.insertImage(reader.result);
            }
            reader.readAsDataURL(fileList[0]);
        }
    }

    setBody = (html) => this.editor.replace(html);

    render() {
        return (
            <Summernote
                ref={summernoteObj => this.editor = summernoteObj}
                //value={this.state.body}
                name="email_editor"
                options={{
                    minHeight: 400,
                    maxHeight: null,

                    dialogsInBody: true,
                    toolbar: [
                        ['style', ['style']],
                        ['font', ['bold', 'underline', 'italic']],//, 'clear'//'strikethrough', 'superscript', 'subscript'
                        ['font', ['strikethrough', 'superscript', 'subscript']],
                        ['fontsize', ['fontsize']],
                        ['color', ['color']],
                        ['fontname', ['fontname']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                        ['insert', ['link', 'picture']],
                        ['view', ['fullscreen']] //'codeview'
                    ]
                }}
                onChange={this.onChange}
                onImageUpload={this.onImageUpload}
            />
        );
    }
}

//class AddressEntryOptimization

class ComposeEmail extends React.Component {

    constructor(props) {
        super(props);
        console.log('Received Props On Load:', props);
        if (props.location && props.location.state && props.location.state.bcc) {
            this.defaultBcc = props.location.state.bcc.map(email => ({ label: email, value: email }))
        }
        this.state.allEmails = props.allEmails;
    }

    defaultBcc = [];

    state = {
        from: "noreply@cellfind.co.za",
        incognito: false,
        allEmails: [],
        subject: '',
        letterhead: { label: "Cellfind", value: "Cellfind" },
        loadingNewEmail: false,
        loadingModal: false,
        loadingMessage: 'Loading...',
        previewOpen: false,
        previewStillVisible: false,
        addTemplateOpen: false,
        addTemplateLoading: false,
        sendPendingOpen: false,
        sendingInProgress: false,
        notificationOpen: false,
        notification: '',
        selectTemplateOpen: false
    }

    componentDidMount() {
        console.log('State:', this.state);
        console.log('Props:', this.props);
    }

    render() {

        return (
            <Card> {/* className="summernote-incognito" */}
                <CardBody>

                    <CustomInput
                        disabled
                        readOnly
                        labelText={"From"}
                        id="from"
                        formControlProps={{
                            fullWidth: true,
                            disabled: true
                        }}
                        inputProps={{
                            onChange: event => this.setState({ from: event.target.value }),
                            value: this.state.from,
                            readOnly: true,
                            disabled: true
                        }}
                    />

                    <SelectEmailAddress
                        ref={to => this.to = to}
                        label="To"
                        placeholder="Required *"
                        allEmails={this.state.allEmails}
                        add={(email, cb) => this.setState({ allEmails: this.state.allEmails.concat([{ label: email, value: email }]) }, cb)}
                    />

                    <SelectEmailAddress
                        ref={cc => this.cc = cc}
                        label="CC"
                        placeholder="Optional"
                        allEmails={this.state.allEmails}
                        add={(email, cb) => this.setState({ allEmails: this.state.allEmails.concat([{ label: email, value: email }]) }, cb)}
                    />

                    <SelectEmailAddress
                        ref={bcc => this.bcc = bcc}
                        defaultValue={this.defaultBcc}
                        label="BCC"
                        placeholder="Optional"
                        allEmails={this.state.allEmails}
                        add={(email, cb) => this.setState({ allEmails: this.state.allEmails.concat([{ label: email, value: email }]) }, cb)}
                    />

                    <CustomInput
                        labelText={"Subject"}
                        id="subject"
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                            inputProps: {
                                ref: subject => this.subject = subject,
                            }
                        }}
                    />

                    <ReactSelect
                        label="Letterhead"
                        options={[
                            { label: "Cellfind", value: "Cellfind" },
                            { label: "Panacea", value: "Panacea" },
                            { label: "Simigenix", value: "Simigenix" }
                        ]}
                        onChange={(value) => this.setState({ letterhead: value })}
                        value={this.state.letterhead}
                    />

                    <div style={{ display: 'block', position: 'relative', width: '100%', textAlign: 'center', paddingBottom: 50, paddingTop: 50 }}>
                        <img
                            width={100}
                            height={100}
                            style={{ textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', borderRadius: '50%', overflow: 'hidden' }}
                            src={getLetterheadImage(this.state.letterhead.value)}
                        />
                        {/* faBookmark -> Select Template */}
                    </div>

                    <SummernoteOptimization ref={summernote => this.summernote = summernote} />
                    <br />
                    <div style={{ width: '100%' }}>
                        <div style={{ textAlign: 'left', float: "left" }}>
                            <Button color="success" round onClick={() => this.setState({ selectTemplateOpen: true })}>
                                <FontAwesomeIcon icon={faCopy} />&nbsp;&nbsp;&nbsp;Use Template
                            </Button>
                        </div>
                        <div style={{ textAlign: "right", float: "right" }}>
                            <Button color="rose" round onClick={() => this.setState({ addTemplateOpen: true })}>
                                <FontAwesomeIcon icon={faBookmark} />&nbsp;&nbsp;&nbsp;Save as Template
                        </Button>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                        <Button color="info" round onClick={() => this.setState({ previewOpen: true, previewStillVisible: true }, () => this.emailPreview.forceUpdate())}>
                                <FontAwesomeIcon icon={faPresentation} />&nbsp;&nbsp;&nbsp;Preview
                        </Button>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                        <Button
                                onClick={() => this.setState({ sendPendingOpen: true })}
                                color="primary"
                                round
                            >
                                <FontAwesomeIcon icon={faPaperPlane} />&nbsp;&nbsp;&nbsp;Send
                        </Button>
                        </div>
                    </div>

                    <EmailPreview
                        innerRef={emailPreview => this.emailPreview = emailPreview}

                        open={this.state.previewOpen}
                        close={() => this.setState({ previewOpen: false })}

                        onExited={() => this.setState({ previewStillVisible: false })}
                        onTemplateClick={() => this.setState({ addTemplateOpen: true })}
                        onSendClick={() => this.setState({ sendPendingOpen: true })}

                        from={this.state.from}
                        to={() => this.to && this.to.state.selected.map(x => x.value).join('; ')}
                        cc={() => this.cc && this.cc.state.selected.map(x => x.value).join('; ')}
                        bcc={() => this.bcc && this.bcc.state.selected.map(x => x.value).join('; ')}
                        subject={() => this.subject && this.subject.value}
                        body={() => this.summernote && this.summernote.state.body}
                        letterhead={this.state.letterhead.value}
                    />

                    <SelectTemplate
                        innerRef={selectTemplate => this.selectTemplate = selectTemplate}
                        open={this.state.selectTemplateOpen}
                        close={(template) => {
                            if (template) {
                                this.summernote.setBody(template.body);
                                this.summernote.setState({ body: template.body });
                                this.setState({ selectTemplateOpen: false, letterhead: { label: template.letterhead, value: template.letterhead } });
                            }
                            else {
                                this.setState({ selectTemplateOpen: false });
                            }
                        }}
                    />

                    <SingleInputModal
                        open={this.state.addTemplateOpen && !this.state.previewStillVisible}
                        close={() => this.setState({ addTemplateOpen: false })}

                        title="Add New Email Template"
                        labelText="Template Name"

                        confirmText="Add Template"
                        confirmIcon={faPlus}

                        onConfirm={(inputValue) =>
                            this.setState({ addTemplateLoading: true }, () => {
                                Api.post(EmailEndpoints.addTemplate, { body: this.summernote.state.body, letterhead: this.state.letterhead.value, name: inputValue })
                                    .then(({ data }) => {
                                        //TODO: Confirmation of new template
                                        console.log(data);
                                        this.setState({ addTemplateLoading: false, addTemplateOpen: false, notification: 'Template Added Successfully', notificationOpen: true })
                                        this.selectTemplate.refreshData();
                                        //this.summernote.setBody(data);
                                    })
                                    .catch((e) => {
                                        this.setState({ addTemplateLoading: false, addTemplateOpen: false })
                                        console.error(e);
                                    })
                            })
                        }

                        loading={this.state.addTemplateLoading}
                    />

                    <SmallModal
                        isOpen={this.state.sendPendingOpen && !this.state.sendingInProgress && !this.state.previewStillVisible}
                        close={() => this.setState({ sendPendingOpen: false })}
                        accept={() => {
                            if (!this.state.sendingInProgress) {
                                this.setState({ sendingInProgress: true, loadingModal: true, loadingMessage: "Sending..." }, () => {
                                    Api.post(
                                        EmailEndpoints.send,
                                        {
                                            from: this.state.from,
                                            to: this.to.state.selected.map(x => x.value),
                                            cc: this.cc.state.selected.map(x => x.value),
                                            bcc: this.bcc.state.selected.map(x => x.value),
                                            subject: this.subject.value,
                                            body: this.summernote.state.body,
                                            letterhead: this.state.letterhead.value
                                        }
                                    )
                                        .then(({ data }) => {
                                            if (data.status === "error") {
                                                this.setState({ notification: "Partial Success\nFailed to Send to:\n" + data.fail.join(',\n'), notificationOpen: true, sendPendingOpen: false, sendingInProgress: false, loadingModal: false });
                                            } else {
                                                this.setState({ notification: "Emails Sent!", notificationOpen: true, sendPendingOpen: false, sendingInProgress: false, loadingModal: false });
                                            }
                                        })
                                        .catch((e) => {
                                            console.error(e)
                                            this.setState({ notification: "Critical Error...\n Something caused the email to fail entirely...", notificationOpen: true, sendPendingOpen: false, sendingInProgress: false, loadingModal: false });
                                        })
                                })
                            }

                        }}
                    >
                        Are you sure are the given details are correct and that you want to send this email?
                    </SmallModal>

                    <NotificationModal
                        open={this.state.notificationOpen && !this.state.previewStillVisible}
                        close={() => this.setState({ notificationOpen: false })}
                    >
                        <h5 style={{ whiteSpace: 'pre-wrap' }}>{this.state.notification}</h5>
                    </NotificationModal>

                    <NotificationModal
                        open={this.state.loadingModal && !this.state.previewStillVisible}
                        close={() => this.setState({ loadingModal: false })}
                    >
                        <>
                            <Loading />
                            <br />
                            {this.state.loadingMessage}
                        </>
                    </NotificationModal>

                </CardBody>
            </Card>
        );
    }

}

const mapStateToProps = (state) => ({ allEmails: state.emails.list })

export default withStyles(extendedFormsStyle)(connect(mapStateToProps)(ComposeEmail));